export type MeetingType = 
  | 'PARENT_TEACHER'
  | 'DISCIPLINARY'
  | 'ACADEMIC_REVIEW'
  | 'TUTORING'
  | 'STAFF'
  | 'DEPARTMENT'
  | 'IEP'
  | 'COUNSELING'
  | 'CLUB'
  | 'ADMINISTRATIVE';

export enum ParticipantRole {
  TEACHER = 'TEACHER',
  PARENT = 'PARENT',
  STUDENT = 'STUDENT',
  ADMIN = 'ADMIN',
  COUNSELOR = 'COUNSELOR',
  DEPARTMENT_HEAD = 'DEPARTMENT_HEAD'
}

export interface Participant {
  id: string;
  name: string;
  email: string;
  role: ParticipantRole;
  avatar?: string;
  attendance?: 'PRESENT' | 'ABSENT' | 'LATE';
}

export interface AgendaItem {
  id: string;
  title: string;
  duration: number; // in minutes
  description: string;
  presenter?: Participant;
}

export interface Task {
  id: string;
  title: string;
  assignee: Participant;
  dueDate: Date;
  status: 'PENDING' | 'IN_PROGRESS' | 'COMPLETED';
  description: string;
}
import { FileAttachment, FileTag } from './file';

export interface Meeting {
  id: string;
  type: MeetingType;
  title: string;
  description: string;
  startTime: Date;
  endTime: Date;
  location: string;
  isVirtual: boolean;
  meetingLink?: string;
  participants: Participant[];
  agenda: AgendaItem[];
  tasks: Task[];
  notes: string;
  status: 'SCHEDULED' | 'IN_PROGRESS' | 'COMPLETED' | 'POSTPONED' | 'CANCELLED';
  attachments?: FileAttachment[];
  tags?: FileTag[];
  recurrence?: {
    frequency: 'DAILY' | 'WEEKLY' | 'MONTHLY' | 'CUSTOM';
    interval: number;
    daysOfWeek?: number[];
    endDate?: Date;
    occurrences?: number;
    exceptions?: Date[];
  };
}

export interface RecurrencePattern {
  frequency: 'DAILY' | 'WEEKLY' | 'MONTHLY' | 'CUSTOM';
  interval: number;
  daysOfWeek?: number[];
  endDate?: Date;
  occurrences?: number;
}

export interface MeetingTemplate {
  id: string;
  name: string;
  type: MeetingType;
  purpose: string;
  requiredRoles: ParticipantRole[];
  defaultDuration: number;
  agendaTemplate: Omit<AgendaItem, 'id'>[];
  description: string;
  createdAt: Date;
  updatedAt: Date;
}